export default __webpack_public_path__ + "13d3a4fa537c654a6c0026b62262dd20.png";